{/*
  import axios from 'axios';
  
  const handleGeneratePdf = async (prod_id, proj_id, tecResp, obs, status, avaliacoes, aprovaOuReprova) => {
      try {
        const response = await axios.post('http://localhost:3001/generate-pdf', { prod_id, proj_id, tecResp, obs, status, avaliacoes, aprovaOuReprova }, { withCredentials:true, responseType: 'blob' });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${Date.now()}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    };
  
  export default handleGeneratePdf;
*/}